module.exports = __webpack_public_path__ + "static/media/achesoothe-logo.4b66a687.png";